import styled from 'styled-components';

export const Wrapper = styled.p`
  align-items: center;
  color: ${({ theme }) => theme.colors.gray};
  display: flex;
  flex-flow: column;
  font-size: 14px;
  justify-content: center;
  line-height: 20px;
  margin-top: 100px;
  text-align: center;
  white-space: pre;

  & > svg {
    margin: 0 0 20px 100px;
  }
`;
